import {
  Autocomplete,
  IconButton,
  ListItem,
  ListItemText,
  TextField,
} from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import React from 'react'
import { useAPI } from '../../../api'
import { useTranslation } from 'react-i18next'
import usePrintStore from '../../../store/printStore'
import fetch from '../../../api/axios'
import DeleteIcon from '@mui/icons-material/Delete'
import { AxiosResponse } from 'axios'
import { Filter } from '../../Invoice/types'
import { PrintTemplate } from '../../OCRImport/types'

interface TemplateListSearchProps {
  isPrintScreen?: Boolean
  filter?: Filter | null
  onChangeIndicator: (
    isValueSelected: boolean,
    template: PrintTemplate | null
  ) => void
}

export function TemlateListSearch({
  filter = undefined,
  onChangeIndicator,
  isPrintScreen = true,
}: TemplateListSearchProps) {
  const { t } = useTranslation()
  const api = useAPI()
  const resource = 'print-template'
  const [open, setOpen] = React.useState(false)
  const [options, setOptions] = React.useState<readonly PrintTemplate[]>([])
  const {
    setProducts: updateProductList,
    setPrintTemplateId: updateStorePrintTemplateId,
  } = usePrintStore()
  const loading = open && options.length === 0
  React.useEffect(() => {
    let active = true
    if (!loading) {
      return undefined
    }
    ;(async () => {
      const resource = 'print-template'
      let results: AxiosResponse<any, any>
      if (!filter) {
        results = await fetch.get(resource)
      } else {
        const action = 'filtered-templates'
        const params = { filter: JSON.stringify(filter) }
        results = await fetch.get(`${resource}/${action}/`, { params })
      }
      if (active) {
        setOptions([...results.data])
      }
    })()
    return () => {
      active = false
    }
  }, [loading, filter])

  React.useEffect(() => {
    if (!open) {
      setOptions([])
    }
  }, [open])

  const deleteTemplateMutation = useMutation({
    mutationFn: (id: number) => api.delete(resource, id),
    onSuccess: () => {},
  })

  const handleTemplateSearchChange = async (data: PrintTemplate) => {
      const action = 'details'
      if (isPrintScreen) {
        const get_linked_products = await fetch.get(
          `${resource}/${data.id}/${action}`
        )
        updateStorePrintTemplateId(data.id!)
        updateProductList(get_linked_products.data)
      }
  }
  const handleDeleteTemplate = (event: React.MouseEvent, option: PrintTemplate) => {
    event.stopPropagation()
    if (option.id) {
      deleteTemplateMutation.mutate(Number(option.id))
    }
  }
  return (
    <>
      {' '}
      <Autocomplete
        id="asynchronous-demo"
        disabled={deleteTemplateMutation.isPending}
        sx={{ width: 300 }}
        open={open}
        onOpen={() => {
          setOpen(true)
        }}
        onClose={() => {
          setOpen(false)
        }}
        isOptionEqualToValue={(option, value) => option.name === value.name}
        getOptionLabel={(option) => option.name}
        options={options}
        noOptionsText={t('printLists.noDataMessage')}
        size="small"
        // loading={loading}
        renderInput={(params) => (
          <>
            <TextField
              {...params}
              label={t('printLists.printTemplateList')}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {/* {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null} */}
                    {null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
              InputLabelProps={{
                children: <span>{}</span>,
              }}
            />
          </>
        )}
        onChange={(event, value: PrintTemplate | null, reason) => {
          if (value) {
            // Call the handleNameSelect function when the name is selected
            onChangeIndicator(true, value)
            handleTemplateSearchChange(value)
          }
          if (reason === 'clear') {
            // if the select box is cleared.
            onChangeIndicator(false, null)
          }
        }}
        renderOption={(props, option) => (
          <ListItem {...props} key={option.id}>
            <ListItemText primary={option.name} />
            <IconButton
              edge="end"
              onClick={(event) => handleDeleteTemplate(event, option)}
              size="small"
            >
              {<DeleteIcon />}
            </IconButton>
          </ListItem>
        )}
      />
    </>
  )
}
